var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2M5Tg2DEZwz9-vEJ3ElIR"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

const MF_NAME = process.env.NEXT_PUBLIC_MF_NAME ?? "mf-unknown";
const RELEASE = process.env.NEXT_PUBLIC_RELEASE ?? "0.0.0";
const ENV = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? "development";
const DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: DSN,
  release: `${MF_NAME}@${RELEASE}`,
  environment: ENV,

  autoSessionTracking: false,

  sampleRate: 1.0,
  tracesSampleRate: 0.1,

  initialScope: {
    tags: {
      mf_name: MF_NAME,
      release: RELEASE,
    },
  },

  beforeSend(event, hint) {
    const error = hint?.originalException;

    if (error instanceof TypeError && error.message === "Failed to fetch") {
      return null;
    }

    if (error instanceof Error && error.name === "ChunkLoadError") {
      return null;
    }

    if (error instanceof DOMException && error.name === "AbortError") {
      return null;
    }

    event.tags = {
      ...event.tags,
      mf_name: MF_NAME,
    };

    return event;
  },

  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});

// Restore user context from localStorage on init
try {
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem("data");
    if (stored) {
      const userData = JSON.parse(stored);
      if (userData?.pernr) {
        Sentry.setUser({
          id: userData.pernr,
          username: userData.sname || userData.pernr,
        });
      }
    }
  }
} catch {
  // localStorage may not be available or data may be malformed
}
